import React, { useState, useEffect } from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import './blink.css' // Make sure you have fade-in and fade-out CSS

interface BlinkingTextProps {
  textsToBlink: string[]
}

const BlinkingText: React.FC<BlinkingTextProps> = ({ textsToBlink }) => {
  const [currentTextIndex, setCurrentTextIndex] = useState(0)
  const [isVisible, setIsVisible] = useState(true) // To handle visibility for fade-in and fade-out

  // Helper function to shuffle texts array
  const shuffleArray = (array: string[]) => {
    return array.sort(() => Math.random() - 0.5)
  }

  // Shuffle the textsToBlink once when the component is mounted
  const [shuffledTexts, setShuffledTexts] = useState<string[]>([])

  useEffect(() => {
    setShuffledTexts(shuffleArray([...textsToBlink])) // Shuffle and set the textsToBlink
  }, [textsToBlink])

  useEffect(() => {
    if (shuffledTexts.length > 0) {
      const intervalId = setInterval(() => {
        setIsVisible(false) // Start fading out the current text

        // After the fade-out completes, switch to the next text
        setTimeout(() => {
          setCurrentTextIndex((prevIndex) =>
            prevIndex === shuffledTexts.length - 1 ? 0 : prevIndex + 1
          )
          setIsVisible(true) // Fade in the new text
        }, 500) // Duration of fade-out before switching text
      }, 2500) // Total cycle time: 2000ms for fade-in + visible time, 500ms for fade-out

      // Cleanup interval on component unmount
      return () => clearInterval(intervalId)
    }
  }, [shuffledTexts])

  return (
    <div className="blinking-text-wrapper">
      <TransitionGroup>
        <CSSTransition
          key={currentTextIndex}
          timeout={500} // The transition duration matches the CSS for fade-out
          classNames="fade"
        >
          <div className={`blinking-text ${isVisible ? 'fade-in' : 'fade-out'}`}>
            {shuffledTexts[currentTextIndex]}
          </div>
        </CSSTransition>
      </TransitionGroup>
    </div>
  )
}

export default BlinkingText
